module.exports = __webpack_public_path__ + "443fdf92044836000c031ab0c30c346d.svg";